module.exports = __webpack_public_path__ + "img/18f2645.png";